import React, { useState } from 'react';
import styled from '@emotion/styled';
import List from '../../../components/list/list';
import moment from 'moment';
import Search from './componentes/search';
import { useLazyQuery, useQuery } from 'react-apollo';
import {
  FIND_RELATORIO_PAGAMENTOS_IA,
  FIND_RELATORIO_PAGAMENTOS_IA_CSV,
} from '../../../graphql/queryes';
import ButtonFloat from '../../../components/button/ButtonFloat';
import { ArrowDownloadIcon } from '../../../components/icons/ArrowDownload';


const columns = [
  {
    title: 'Nome',
    value: (item) => item.nome,
  },
  {
    title: 'Documento',
    value: (item) => item.documento,
  },
  {
    title: 'Email',
    value: (item) => item.email,
  },
  {
    title: 'Valor',
    value: (item) => item.valor,
  },
  {
    title: 'Ultimo pagamento',
    value: (item) => moment(item.dataHoraUltimoPagamento).format('DD/MM/YYYY'),
  },
  {
    title: 'Qtd parc.',
    value: (item) => item.quantidadeParcelas,
  },
  {
    title: 'Endereço',
    value: (item) => item.enderecosUnidades,
  },
];

const pageableDTODefault = {
  pageNumber: 0,
  pageSize: 30,
};

const filtersDefault = {
  search: '',
  dataInicio: moment().startOf('month').format('YYYY-MM-DD'),
  dataFim: moment().endOf('month').format('YYYY-MM-DD'),
};

const PagamentoIA = () => {
  const [filters, setFilters] = useState({ ...filtersDefault });

  const { data, loading, error, refetch, fetchMore } = useQuery(
    FIND_RELATORIO_PAGAMENTOS_IA,
    {
      variables: {
        pageableDto: {
          ...pageableDTODefault,
        },
        ...filters,
      },
      fetchPolicy: 'no-cache',
      skip:
        !filters.dataInicio ||
        !filters.dataFim ||
        filters.dataInicio.trim() === '' ||
        filters.dataFim.trim() === '',
    }
  );

  const [getRelatorioCsv, { refetch: refetchCsv }] = useLazyQuery(
    FIND_RELATORIO_PAGAMENTOS_IA_CSV,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        const base64Data = data?.relatorioPagamentosIaCsv;
        if (!base64Data) return;

        const link = document.createElement('a');
        link.href = `data:text/csv;base64,${base64Data}`;
        link.download = `pagamento-ia-${moment().format('YYYY-MM-DD')}.csv`;
        document.body.appendChild(link);
        link.click();
        link.remove();
      },
    }
  );

  const handleLoadMore = () => {
    const possuiDataInicialEfinal = filters.dataInicio && filters.dataFim;
    if (!data?.findAllPagamentosIa?.last || !!possuiDataInicialEfinal) {
      fetchMore({
        variables: {
          pageableDTO: {
            ...pageableDTODefault,
            pageNumber: data?.findAllPagamentosIa?.number + 1,
          },
          ...filters,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;

          return {
            findAllPagamentosIa: {
              ...prev.findAllPagamentosIa,
              ...fetchMoreResult.findAllPagamentosIa,
              content: [
                ...prev.findAllPagamentosIa.content,
                ...fetchMoreResult.findAllPagamentosIa.content,
              ],
            },
          };
        },
      });
    }
  };

  const dowloadCsv = async () => {
    try {
      getRelatorioCsv({
        variables: {
          search: filters.search || null,
          dataInicio: filters.dataInicio,
          dataFim: filters.dataFim,
        },
      });
    } catch (e) {
      console.error('Erro ao baixar CSV:', e);
    }
  };

  return (
    <ContentRelatorioPagamentoIa>
      <Search
        setFilters={setFilters}
        filters={filters}
        loadRelatorio={handleLoadMore}
      />
      <List
        columns={columns}
        items={data?.findAllPagamentosIa?.content}
        loading={loading}
        error={error}
        last={data?.findAllPagamentosIa?.last}
        onLoadMore={handleLoadMore}
      />
      <ButtonFloat
        title="DowloadCsv"
        icon={<ArrowDownloadIcon />}
        onClick={() => dowloadCsv()}
      />
    </ContentRelatorioPagamentoIa>
  );
};

const ContentRelatorioPagamentoIa = styled.div`
  padding: 16px;
`;
export default PagamentoIA;
